
import { EcommerceAPIApi as EcommerceApi, type PermitRateCouponOutput } from '@parkingbase/ecommerce-api-demo';
import { BaseApiService } from './baseApi.service';

export class PermitRateService extends BaseApiService {
  protected permitRateCardApi: EcommerceApi;

  constructor() {
    super();
    this.permitRateCardApi = new EcommerceApi(this.apiConfig, undefined, this.apiClient);
  }

  async getUIPermitRateCardsForEcommerce() {
    const response = await this.permitRateCardApi.getUIPermitRateCardsForEcommerce();
    return response.data;
  }

  async getPermitRatesForGarage(
    company: string,
    garageId: string,
    startDate: string,
    accountId?: string
  ) {
    const response = await this.permitRateCardApi.getPermitRatesForGarage(
      company,
      garageId,
      startDate,
      accountId
    );
    return response.data;
  }

  async applyCouponPermitRate(
    company: string,
    garageId: string,
    specialRateId: string,
    couponCode: string,
    startDate: string,
    recaptchaToken?: string,
    accountId?: string
  ): Promise<PermitRateCouponOutput> {
    const options = recaptchaToken
      ? { headers: { 'g-recaptcha-response': recaptchaToken } }
      : undefined;
    const response = await this.permitRateCardApi.applyCouponPermitRate(
      company,
      garageId,
      specialRateId,
      couponCode,
      startDate,
      accountId,
      options
    );
    return response.data;
  }

  async getPermitRatesForCompanyGarage(
    company: string,
    garageId: string,
    startDate: string,
    onlyFacilityRates?: boolean,
    userId?: string
  ) {
    const response = await this.permitRateCardApi.getPermitRatesForCompanyGarage(
      company,
      garageId,
      startDate,
      onlyFacilityRates,
      userId
    );
    return response.data;
  }
}
